import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import {  Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { CookieService } from 'app/services/cookie.service';
import { SidebarTasksService } from 'app/services/sidebar-tasks.service';
import { TaskService } from 'app/task/task.service';

import { TaskStructureComponent } from '../taskstructure/task-structure.component';
import { AddTaskComponent } from '../addtask/add-task.component';

import { Task } from 'app/shared/models/task.model';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'app-task-panel',
  templateUrl: './task-panel.component.html'
})

/**
 * Main component for task panel.
 */
export class TaskPanelComponent implements OnInit {

  tabs: Array<Object>;
  dialogRef: MdDialogRef<any>;
  activeWorks: any[];

  entityIdDetails: EntityIdDetails;
  get myTasks():Array<Task> {
    return this.sidebarTasksService.myTasks;
  }

  get otherTasks(): Array<Task> {
    return this.sidebarTasksService.otherTasks;
  }

  get selectedTabIndex(): Number {
    return this.sidebarTasksService.selectedTabIndex;
  }

  set selectedTabIndex(val:Number) {
    this.sidebarTasksService.selectedTabIndex = val;
  }

  get isLoading(): Boolean {
    return this.sidebarTasksService.isLoading;
  }

  // Constructor method
  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialog: MdDialog,
    private cookieService: CookieService,
    private sidebarTasksService: SidebarTasksService,
    private entityDetailsService: EntityDetailsService,
    private taskService: TaskService) {
    this.sidebarTasksService.onTasksChanged.asObservable().subscribe(isLoading => {
      this.tabs = [
        { name: 'My Tasks', tasks: this.myTasks },
        { name: 'Other Tasks', tasks: this.otherTasks }
      ];
    });
  }

  openProcessStructureDialog(activeWorkFlow) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(TaskStructureComponent, config);
    this.dialogRef.componentInstance.activeWorkflow = activeWorkFlow;
    this.dialogRef.componentInstance.entityId = this.sidebarTasksService.entityId.value;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
    });
  }

  onTaskDetailsChange(editResponse: Object) {
    this.sidebarTasksService.loadTasks();
  }

  openAddTaskDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(AddTaskComponent, config);
    this.dialogRef.componentInstance.action = 'Add';
    this.dialogRef.componentInstance.entityId = this.sidebarTasksService.entityId.value;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sidebarTasksService.loadTasks();
      }
      this.dialogRef = null;
    });
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    if (this.entityIdDetails.entityId) {
      this.loadActiveWorkFlow();
    } else {
      this.entityDetailsService.entityDetailsUpdated.subscribe(
        (entityDetails) => {
          this.entityIdDetails = entityDetails;
          this.loadActiveWorkFlow();
        }
      );
    }
    this.taskService.currentMessage.subscribe(message => {
      if (message === 'updateActiveWorkFlow') {
        this.loadActiveWorkFlow();
      }
    });
    this.taskService.currentMessage.subscribe(message => {
      if (message === 'closeActiveWorkFlowDialog') {
        this.dialogRef.close();
      }
    });
  }

  public loadActiveWorkFlow() {
    if (this.entityIdDetails.entityId < 0) { return; }

    this.taskService.getActiveWorkFlows(this.entityIdDetails.entityId).subscribe(
      response => {
       this.activeWorks = response.arrResult;

      });
 }



}



// WEBPACK FOOTER //
// ./src/app/task/taskpanel/task-panel.component.ts